import punycode from "punycode/"

import LinkifyIt from "linkify-it"
import { PureComponent, ReactNode } from "react"

// Affectionately stolen and adapted from here:
// https://github.com/markdown-it/linkify-it/blob/master/support/demo_template/index.js

type LinkifyProps = {
  children?: ReactNode
}

export default class Linkify extends PureComponent<LinkifyProps> {
  static linkify = new LinkifyIt()

  static match(message: string) {
    return this.linkify.match(message)
  }

  static parse(matches: LinkifyIt.Match[] | null, content: string) {
    matches = matches ?? [] // eslint-disable-line no-param-reassign

    const elements: ReactNode[] = []
    let last = 0

    for (let i = 0; i < matches.length; i++) {
      const match = matches[i]

      if (last < match.index) {
        elements.push(content.slice(last, match.index))
      }

      elements.push(
        <a
          href={match.url}
          target="_blank"
          rel="noopener noreferrer"
          key={i}
        >
          {punycode.toASCII(match.text)}
        </a>,
      )

      last = match.lastIndex
    }

    if (last < content.length) {
      elements.push(content.slice(last))
    }

    return elements
  }

  render() {
    if (typeof this.props.children !== "string") {
      return this.props.children
    }

    const matches = Linkify.match(this.props.children)

    if (!matches) {
      return <span>{this.props.children}</span>
    }

    return <span>{Linkify.parse(matches, this.props.children)}</span>
  }
}
